import PropTypes from 'prop-types';
import { groupNeededByBook } from '../../utils/communityBooks';
import './RemainingChapters.css';

/**
 * Just the chapters still standing between the community and its next
 * complete read-through, as a compact list by book. The map shows the same
 * chapters highlighted in place; this is the list to read down.
 */
const RemainingChapters = ({ chaptersNeeded = [] }) => {
  const books = groupNeededByBook(chaptersNeeded);
  if (books.length === 0) return null;

  return (
    <ul className="remaining-chapters" aria-label="Chapters still needed">
      {books.map(entry => (
        <li key={entry.book} className="remaining-chapters-book">
          <span className="remaining-chapters-name">{entry.book}</span>
          <span className="remaining-chapters-list">{entry.ranges}</span>
        </li>
      ))}
    </ul>
  );
};

RemainingChapters.propTypes = {
  chaptersNeeded: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    book: PropTypes.string,
    chapter: PropTypes.number,
    testament: PropTypes.string
  }))
};

export default RemainingChapters;
